// tslint:disable:no-empty-interface
import { IconName, Intent } from '@blueprintjs/core'

import {
  BonusPeriodInfoDtoSchema,
  BonusPeriodPartSchema,
  ImageSourceSchema,
  ImageUrlsSchema,
  LookupDtoSchema,
  OrgChartSchema,
  PersonApiGetDtoSchema,
  PersonApiPutDtoSchema,
  StaticFileGetDtoSchema,
  SupervisorPersonDtoSchema,
  TeamPersonDtoSchema,
  UserViewDtoSchema,
} from '../../schemas'

export class UserModel {
  constructor(
    public name: string,
    public height: number,
    public mass: number,
    public gender: string,
    public homeworld: string
  ) {}
}

export interface ToastPayload {
  icon?: IconName
  message: string
  intent?: Intent
  id?: string
}

export interface LookupOption {
  id: number
  name: string
  label: string
}

export interface PersonLookupOption {
  id: number
  name: string
  label: string
  imageUrls: ImageUrls
}

export interface OwnerLookupOption {
  id: number
  name: string
  label: string
}

export const LOGIN_ACCESS_TYPES: Record<string, number> = {
  domain: 1,
  email: 2,
}

export const BadgeType = {
  goal: 10,
  review: 20,
  feedback: 30,
  myTeam: 40,
  teamGoals: 50,
  teamReview: 60,
}

export enum Keycodes {
  Enter = 13,
}

export interface OrgChartDto extends OrgChartSchema {}
export interface PersonApiGetDto extends PersonApiGetDtoSchema {}
export interface PersonApiPutDto extends PersonApiPutDtoSchema {}
export interface TeamPersonApiGetDto extends TeamPersonDtoSchema {}
export interface UserViewGetDto extends UserViewDtoSchema {}

export interface ImageSource extends ImageSourceSchema {}

export interface ImageUrls extends ImageUrlsSchema {}

export interface SupervisorPersonDto extends SupervisorPersonDtoSchema {}
export interface LookupDto extends LookupDtoSchema {}

export interface BlogPostAttachment extends StaticFileGetDtoSchema {}

/** Bonus Periods */
export interface BonusPeriodInfoDto extends BonusPeriodInfoDtoSchema {}
export interface BonusPeriodPart extends BonusPeriodPartSchema {}



// WEBPACK FOOTER //
// ./src/app/shared/model.ts